module.exports = __webpack_public_path__ + "static/media/github.bbd7ea09.webp";